import { styled } from 'dripsy';
import React, { useState } from 'react';
import { View } from 'react-native';
import { observer } from 'mobx-react-lite';

import { Post } from '@models/Posts/PostModel';
import { Image } from '../../common/Image';
import { Touchable } from '../../common/Touchable';
import { Icon } from '../../common/Icon';

const PostImagesContainer = styled(View)({
  flex: 1,
});

const ControlContainer = styled(View)({
  size: 40,
  borderRadius: 12,
  overflow: 'hidden',
  position: 'absolute',
  top: '50%',
  transform: [{ translateY: -20 }],
});

const ControlTouchableContainer = styled(Touchable)({
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
});

const ControlContainerBackground = styled(View)({
  zIndex: -1,
  position: 'absolute',
  width: '100%',
  height: '100%',
  bg: '$background0',
  opacity: 0.2,
});

const PrevButtonContainer = styled(ControlContainer)({
  left: 8,
});

const NextButtonContainer = styled(ControlContainer)({
  right: 8,
});

const PostImageContainer = styled(View)({
  flex: 1,
  borderRadius: 12,
  bg: '$background20',
  overflow: 'hidden',
});

const PostImage = styled(Image)({
  flex: 1,
});

const PostImageThumbnail = styled(Image)({
  position: 'absolute',
  width: '100%',
  height: '100%',
});

export interface IPostViewImagesProps {
  initialIndex?: number;
  item: Post;
}

export const PostViewImages = observer<IPostViewImagesProps>(
  ({ initialIndex = 0, item }) => {
    const [currentImageIndex, setCurrentImageIndex] =
      useState(initialIndex);

    function prevImage() {
      setCurrentImageIndex((v) => Math.max(v - 1, 0));
    }

    function nextImage() {
      setCurrentImageIndex((v) =>
        Math.min(v + 1, item.itemData.images.length - 1),
      );
    }

    const isFirstImage = currentImageIndex === 0;
    const isLastImage =
      currentImageIndex === item.itemData.images.length - 1;
    const image = item.itemData.images[currentImageIndex];

    return (
      <PostImagesContainer>
        <PostImageContainer>
          <PostImageThumbnail
            contentFit="contain"
            source={{
              uri: image.normal?.url,
            }}
          />
          <PostImage
            contentFit="contain"
            source={{
              uri: image.big?.url,
            }}
          />
        </PostImageContainer>

        {!isFirstImage && (
          <PrevButtonContainer>
            <ControlContainerBackground />
            <ControlTouchableContainer onPress={prevImage}>
              <Icon size={24} name="small-arrow-left-light" />
            </ControlTouchableContainer>
          </PrevButtonContainer>
        )}

        {!isLastImage && (
          <NextButtonContainer>
            <ControlContainerBackground />
            <ControlTouchableContainer onPress={nextImage}>
              <Icon size={24} name="small-arrow-right-light" />
            </ControlTouchableContainer>
          </NextButtonContainer>
        )}
      </PostImagesContainer>
    );
  },
);
